import { render } from "./VoteOverview.vue?vue&type=template&id=b0c1be8a&scoped=true"
import script from "./VoteOverview.vue?vue&type=script&lang=js"
export * from "./VoteOverview.vue?vue&type=script&lang=js"

import "./VoteOverview.vue?vue&type=style&index=0&id=b0c1be8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0c1be8a"]])

export default __exports__